<template>
  <div class="homeGoodBusiness HomeContainer">
    <div class="nav">
      <div class="title">{{l("优选好商")}}</div>
      <div
        v-for="tag of $store.state.basicInfo.tagList.good_business"
        :key="tag.id"
        class="tag"
        :class="{ selected: tag.id == SearchData.tag_id }"
        @click="SearchData.tag_id = tag.id"
      >
        <div class="point"></div>
        <div class="name">
          {{ tag.name }}
        </div>
      </div>
    </div>

    <div class="tableContainer">
      <div v-if="carouselList[0]" class="carousel">
        <el-carousel
          :autoplay="true"
          :style="{ background: carouselList[0].background }"
        >
          <el-carousel-item v-for="item of carouselList" :key="item.url">
            <el-image
              :src="item.url"
              fit="cover"
              @click="clickCarousel(item)"
            ></el-image>
          </el-carousel-item>
        </el-carousel>
      </div>
      <template v-if="TableList.length">
        <div class="companyContainer">
          <div v-for="item of TableList" :key="item.id" class="companyItem">
            <div class="logoContainer">
              <el-image :src="item.logo" fit="contain" class="logo"></el-image>
            </div>
            <div class="textContainer">
              <div class="name one_lines">{{ item.name }}</div>
              <div class="description">{{ item.description }}</div>
            </div>
            <div class="divider"></div>
          </div>
        </div>
        <el-pagination
          style="justify-content: center; margin: 35px 0"
          background
          @current-change="HandleCurrentChange"
          :current-page="CurrentPage"
          :page-size="PageSize"
          layout="total, prev, pager, next, jumper"
          :total="TotalCount"
        ></el-pagination>
      </template>

      <el-empty
        v-else
        :description="l('抱歉，暂时没有收录该类商家')"
        style="margin-top: 100px"
      >
      </el-empty>
    </div>
  </div>
</template>

<script>
import tableMixin from "@/assets/js/tableMixin";

export default {
  name: "HomeGoodBusiness",
  mixins: [tableMixin],
  data() {
    return {
      GetTableListWhenMounted: false,
      SearchData: {
        tag_id: "",
      },
      PageSize: 8,
      carouselList: [],
    };
  },
  created() {
    if (this.$store.state.basicInfo.tagList.good_business) {
      this.SearchData.tag_id =
        this.$store.state.basicInfo.tagList.good_business[0].id;
    }
    if (this.$route.query.tag_id) {
      this.SearchData.tag_id = this.$route.query.tag_id;
    }
  },
  watch: {
    "$store.state.basicInfo.tagList.good_business"() {
      this.SearchData.tag_id =
        this.$store.state.basicInfo.tagList.good_business[0].id;
    },
    "SearchData.tag_id"() {
      this.GetTableList(true);
      this.getCarousel();
    },
  },
  methods: {
    GetTableList(resetPage) {
      if (resetPage == true) this.CurrentPage = 1;
      this.axios
        .get("/api/good_business/", {
          params: {
            ...this.SearchData,
            ordering: this.Sorting,
            size: this.PageSize,
            page: this.CurrentPage,
          },
        })
        .then((data) => {
          this.TotalCount = data.count;
          this.TableList = data.results;
        });
    },
    getCarousel() {
      this.axios
        .get("/api/banner/", {
          params: {
            position: "good_business_" + this.SearchData.tag_id,
            show_pc: true,
            is_show: true,
          },
        })
        .then((data) => {
          this.carouselList = data;
        });
    },
    clickCarousel(item) {
      if (item.path_pc) {
        if (item.path_pc.indexOf("http") == 0) {
          window.open(item.path_pc);
        } else {
          this.$router.push({ path: item.path_pc });
        }
      }
    },
  },
};
</script>


<style scoped lang="scss">
.homeGoodBusiness {
  display: flex;
  justify-content: space-between;
  padding-top: 21px;
  .nav {
    width: 208px;
    background: #fff;
    .title {
      font-weight: bold;
      margin-top: 25px;
      margin-bottom: 25px;
      padding-left: 40px;
    }
    .tag {
      margin-bottom: 20px;
      display: flex;
      align-items: center;
      margin-left: 46px;
      cursor: pointer;
      .point {
        width: 5px;
        height: 5px;
        border-radius: 50%;
        background: #999;
      }
      .name {
        margin-left: 25px;
      }
      &:hover,
      &.selected {
        .point {
          background: $warningColor;
        }
        .name {
          color: $warningColor;
        }
      }
    }
  }
  .tableContainer {
    background: #fff;
    width: 975px;
    padding: 0 20px;
    box-sizing: border-box;
    .carousel {
      width: 100%;
      height: 142px;
      position: relative;
      margin-top: 20px;

      .el-carousel {
        width: 100%;
        height: 100%;
        /deep/.el-carousel__container {
          height: 100%;
          .el-carousel__item {
            height: 100%;
          }

          .el-carousel__item .el-image {
            height: 100%;
            width: 100%;
          }
        }
      }
    }
    .companyContainer {
      display: flex;
      justify-content: space-between;

      flex-wrap: wrap;
      .companyItem {
        width: 450px;
        display: flex;
        justify-content: space-between;
        box-sizing: border-box;
        padding-top: 22px;
        padding-bottom: 22px;
        border-bottom: 1px solid $borderPlainColor;
        position: relative;
        .divider {
          position: absolute;
          right: -17px;
          top: 0;
          height: 100%;
          width: 1px;
          background: $borderPlainColor;
        }
        &:nth-child(2n) {
          .divider {
            display: none;
          }
        }
        .logoContainer {
          width: 167px;
          height: 124px;
          border: 1px solid $borderColor;
          .logo {
            width: 123px;
            height: 66px;
            margin-left: 22px;
            margin-top: 28px;
          }
        }
        .textContainer {
          width: 260px;
          .name {
            font-size: 18px;
            margin-top: 10px;
          }
          .description {
            color: #999;
            margin-top: 12px;
            line-height: 24px;
            max-height: 72px;
            overflow: hidden;
          }
        }
      }
    }
  }
}
</style>

